<!-- 新建开票 -->
<template>
  <div id="createInvoice">
    <el-button class="glo_bgcMainColor saveBtn" @click="createInvoice">
      保存</el-button
    >
    <div class="formPanel" ref="formPanel">
      <el-form
        :model="baseInForm"
        ref="baseInForm"
        label-width="100px"
        class="glo_formBox"
      >
        <el-form-item label="对账单号:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="对账金额:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="开票金额:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="未开票金额:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="已开票金额:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发票类型:" prop="aaa">
          <el-select v-model="baseInForm.bbb" placeholder="请选择">
            <el-option label="开票" value="1" />
            <el-option label="收票" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发票号:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="开票日期:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="开票项目:" prop="aaa">
          <el-select v-model="baseInForm.bbb" placeholder="请选择">
            <el-option label="全部" value="shanghai" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户税率:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="客户税金:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发票税率:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发票税金:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="付款方名称:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="付款方识别号:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="收款方姓名:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="收款方识别号:" prop="aaa">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="aaa"
        >
          <el-input
            type="textarea"
            rows="2"
            v-model="baseInForm.aaa"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :showSumm="true"
      :totals="totalArr"
      @selectChange="handleSelectionChange"
    ></table-plug>
  </div>
</template>
  <script >
import TablePlug from "@/components/Modules/TablePlug.vue";

export default {
  components: {
    TablePlug,
  },
  data() {
    return {
      baseInForm: {
        aaa: "",
        bbb: 1,
        ccc: 0,
      },
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
        ],
      },
      myTableHeard: [
        {
          name: "收支单据号",
          field: "a",
          width: "120", //default 120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default false
          isSort: true, //表格设置里面是否可以排序 default false
        },
        {
          name: "责任部门",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "收支类型",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "单据类型",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "来源单据",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "费项类型",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "费项",
          field: "b",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "结算对象类型",
          field: "b",
          width: "160",
          sort: 4,
          isShow: true,
        },
        {
          name: "结算对象",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "金额",
          field: "b",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "b",
          width: "120",
          sort: 4,
          isShow: true,
        },
        {
          name: "对账单号",
          field: "b",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "审核状态",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "审核人",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "核销状态",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "最新核销人",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "最新核销时间",
          field: "b",
          width: "160",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "最新资金账号",
          field: "b",
          width: "160",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "最新核销备注",
          field: "b",
          width: "160",
          sort: 4,
          isShow: true,
        },
      ],
      totalArr: [],
    };
  },
  computed: {},
  activated() {
    // 每次进页面都会触发的写这里
    this.height();
  },
  methods: {
    // // 表格选择事件
    handleSelectionChange(e) {
      console.log("表格选择事件");
    },
    // 分页的方法
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 生成对账单
    createInvoice() {
      this.$router.go(-1);
    },

    height() {
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      let queryHeigth = this.$refs.formPanel.offsetHeight + 50;
      let otherHeight = queryHeigth + 80;
      this.$nextTick(() => {
        this.tableConfig.tableHeigth = Math.floor(windonHeight - otherHeight);
      });
    },
  },
};
</script>
  <style scoped lang="less">
#createInvoice {
  .saveBtn {
    padding: 10px 20px;
  }
  .formPanel {
    padding: 10px 20px;
    margin: 12px 0;
    background: rgba(0, 0, 0, 0.05);
    /deep/ .el-form-item {
      background: #fff !important;
    }
  }
}
</style>
  
  